import { useHistory, useLocation } from "react-router-dom";

import IcServiceMain from "assets/svg/Ic3.3Pilates.svg";

import {
  Container,
} from "components/Service.style";

import { useEffect, useState } from "react";
import {
  EventDetailDataContainer,
  EventDetailDataEachContainer,
  EventDetailDataEachContent,
  EventDetailDataEachTitle,
  EventDetailDesc,
  EventDetailDrawer,
  EventDetailFooterBtn,
  EventDetailFooterContainer,
  EventDetailFooterTitle,
  EventHeaderContainer,
  EventHeaderImg,
  EventHeaderSection,
  EventHeaderTitle
} from "../../EventStyle.style";


import { EventSubmitNew } from "./EventSubmitNew";

import { useRecoilValue } from "recoil";
import { to3DataState } from "states/atoms";

const EventPilatesCertificate = ({ loggedInUser }) => {
  const to3Data = useRecoilValue(to3DataState);
  const history = useHistory();
  const location = useLocation();

  const [showApply, setShowApply] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  if (to3Data === null) {
    return <></>
  }

  const showDrawer = () => {
    setShowApply(true);
  };

  const onClose = () => {
    setShowApply(false);
  };

  const eventServiceData = () => {
    return to3Data;
  }

  const refundAmount = () => {
    const amount = to3Data.billingAmount
    if (amount) {
      return Number(amount).toLocaleString() + " 원"
    } else {
      return "원"
    }
  }

  const getOpponentName = () => {
    const opponentName = to3Data.opponentName
    if (opponentName) {
      return opponentName
    } else {
      return ""
    }
  }

  const getOpponentAddress = () => {
    const address = to3Data.opponentAddress
    if (address) {
      return address
    } else {
      return ""
    }
  }

  return (
    <Container>
      <EventHeaderSection>
        <EventHeaderContainer>
          <EventHeaderImg src={IcServiceMain} />
          <EventHeaderTitle>
            헬스･필라테스 환불
          </EventHeaderTitle>
          <EventDetailDesc>
            법대리 내용증명 서비스를 이용하신 고객님들 중 85% 이상이 환불 문제를 해결했어요.
            법대리 내용증명을 통해 환불 문제를 손쉽게 해결해보세요
          </EventDetailDesc>
        </EventHeaderContainer>
      </EventHeaderSection>
      <EventDetailDataContainer>
        <EventDetailDataEachContainer>
          <EventDetailDataEachTitle>
            환불 요청할 금액
          </EventDetailDataEachTitle>
          <EventDetailDataEachContent>
            {refundAmount()}
          </EventDetailDataEachContent>
        </EventDetailDataEachContainer>
        <EventDetailDataEachContainer>
          <EventDetailDataEachTitle>
            매장의 이름
          </EventDetailDataEachTitle>
          <EventDetailDataEachContent>
            {getOpponentName()}
          </EventDetailDataEachContent>
        </EventDetailDataEachContainer>
        <EventDetailDataEachContainer>
          <EventDetailDataEachTitle>
            매장의 주소
          </EventDetailDataEachTitle>
          <EventDetailDataEachContent>
            {getOpponentAddress()}
          </EventDetailDataEachContent>
        </EventDetailDataEachContainer>
        <EventDetailDesc>
          계약서에 이미 작성된 내용이라 해도, 소비자 보호법을 위반하거나 공정한 거래를 방해하는 경우
          무효화가 가능해요. 불공정 계약으로 인해 환불에 어려움을 겪고 있다면,
          법무법인 명의로 발송하는 내용증명을 통해 손쉽게 해결할 수 있어요.
        </EventDetailDesc>
      </EventDetailDataContainer>
      <EventDetailFooterContainer>
        <EventDetailFooterTitle>
          위 정보로 전문 변호사가<br />무료로 검토해 드릴게요.
        </EventDetailFooterTitle>
        <EventDetailFooterBtn onClick={() => showDrawer()}>
          무료 검토 신청하기
        </EventDetailFooterBtn>
      </EventDetailFooterContainer>
      <EventDetailDrawer
        placement={"bottom"}
        closable={false}
        onClose={onClose}
        open={showApply}
        key={"bottom"}
      >
        <EventSubmitNew
          eventServiceData={eventServiceData()}
          serviceType={"3o3_pilates"} />
      </EventDetailDrawer>
    </Container>
  )
};

export default EventPilatesCertificate;